import {
    ICellMapping,
    ICheckpointRule,
    ITripGrouping,
    TripImportMode,
    TripImportNotFoundBehaviour,
    TripImportAlreadyExistsBehaviour,
} from './create-trip-import-template-dto.interface';

export interface ITripImportTemplateOutputDto {
    id: string;
    organizationId: string;
    name: string;
    description?: string;
    mode?: TripImportMode;
    onNotFound?: TripImportNotFoundBehaviour;
    onAlreadyExists?: TripImportAlreadyExistsBehaviour;
    columnMappings: ICellMapping[];
    grouping?: ITripGrouping;
    checkpoints?: ICheckpointRule[];
    createdAt: string;
    updatedAt?: string;
}
